import { render, staticRenderFns } from "./detail-code.vue?vue&type=template&id=7a32d839"
import script from "./detail-code.vue?vue&type=script&lang=js"
export * from "./detail-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports